import components from './components'
import Hades from './framework'
import './index.css'

export default Hades

const install = Hades.install

Hades.install = (Vue, args) => {
  install.call(Hades, Vue, {
    components,
    ...args,
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(Hades)
}
